// Types
import type { SummaryType } from "../../types"

const bottomCardList: SummaryType[] = [
  {
    label: "COUNT: 13",
    sideLabel: "TOTAL PAYMENT TO SUPPLIERS",
    value: "126,000,000"
  },
  {
    label: "COUNT: 3",
    sideLabel: "TOTAL DEPOSIT TO SUPPLIERS",
    value: "26,000,000"
  },
  {
    label: "COUNT: 2",
    sideLabel: "TOTAL CREDIT TO SUPPLIERS",
    value: "12,456,500"
  },
  {
    label: "COUNT: 24",
    sideLabel: "TOTAL PAYABLE TO SUPPLIERS",
    value: "276,670,000"
  },
  {
    label: "COUNT: 24",
    sideLabel: "TOTAL UNIT ON ORDER",
    value: "276,670,000"
  },
  {
    label: "COUNT: 24",
    sideLabel: "TOTAL UNIT DELIVERED",
    value: "276,670,000"
  },
  {
    label: "COUNT: 24",
    sideLabel: "TOTAL UNIT REJECTED",
    value: "276,670,000"
  }
]

const topCardList: SummaryType[] = [
  {
    label: "COUNT: 56 PO",
    sideLabel: "TOTAL PURCHASE SPEND",
    value: "0"
  },
  {
    label: "COUNT: 26 PO",
    sideLabel: "TOTAL PENDING ORDER",
    value: "0"
  },
  {
    sideLabel: "AVERAGE PURCHASE",
    value: "0"
  },
  {
    sideLabel: "PURCHASE ORDER CYCLE TIME",
    value: "0 DAYS"
  },
  {
    sideLabel: "ONTIME DELIVERY",
    value: "0 DAYS"
  },
  {
    sideLabel: "PURCHASE TO SALE RATIO",
    value: "0%"
  },
  {
    sideLabel: "STOCK TURN OVER RATE",
    value: "0 DAYS"
  }
]

export const cardList = {
  bottom: bottomCardList,
  top: topCardList
}